// extracted by mini-css-extract-plugin
export default {"modalMessageContent":"modalMessage_modalMessageContent__-50GV","closeModalBtn":"modalMessage_closeModalBtn__y0H3O"};